/* eslint-disable react/prop-types */
import AtomButton, {atomButtonDesigns, atomButtonShapes} from '@s-ui/react-atom-button'
import ArrowRight from '@adv-mt/mt-svg-icons/lib/ArrowRight'

import {SIZES} from '../settings.js'

const BASE_CLASS = 'mt-ListCarouselCardNavigation'

export const NavigationCard = ({ctaText, label, onClick, size = SIZES.SMALL, url}) => {
  const handleClick = e => {
    e.preventDefault()
    onClick()
  }
  return (
    <a className={BASE_CLASS} href={url} onClick={handleClick}>
      <span className={`${BASE_CLASS}-title ${BASE_CLASS}-title--${size}`}>{label}</span>
      {ctaText ? (
        <AtomButton
          title={ctaText}
          design={atomButtonDesigns.OUTLINE}
          shape={atomButtonShapes.CIRCULAR}
          rightIcon={<ArrowRight size="medium" />}
          negative
        >
          {ctaText}
        </AtomButton>
      ) : null}
    </a>
  )
}
